{
  "actions": "Actions",
  "browserConnect": "Connect to VM",
  "GB": "GB",
  "listOfVMs": "List of virtual machines",
  "myVMs": "My Virtual Machines (VMs)",
  "noVms": "You have no DAS virtual machines.",
  "noVmsP1": "Depending on project needs, having one may complement your analytics.",
  "noVmsP2": "\"Start a new project\" to initiate the process and we will assess if it will meet your needs.",
  "size": "Size",
  "startVM": "Start the virtual machine",
  "startVMtitle": "Start VM",
  "status": "Status",
  "stopVM": "Shut down virtual machine",
  "stopVMtitle": "Shut down VM",
  "VDLVMs": "vDL Virtual Machines",
  "VmLoadError1": "There was a problem loading the virtual machines. Please try again later or contact ",
  "VmLoadErrorLink": "our support team",
  "VmLoadError2": " if the issue persists.",
  "VM": "The VM",
  "VMName": "VM name",
  "VMStarted": "started successfully",
  "VMStarting": "is starting….",
  "VMConnected": "connected successfully",
  "VMStopping": "is stopping (deallocating)….",
  "VMStopped": "shut down successfully",
  "creating": "Creating",
  "starting": "Starting",
  "running": "Running",
  "stopping": "Shutting down",
  "stopped": "Stopped",
  "deallocating": "Shutting down",
  "deallocated": "Shut down",
  "updating": "Updating",
  "failed": "Failed",
  "succeeded": "Succeeded",
  "deleting": "Deleting",
  "migrating": "Migrating",
  "uploadFiles": "Upload files to VM",
  "downloadFiles": "Download vetted files from VM",
  "autoShutDownSettings": "Auto-shutdown settings",
  "forgotPassword": "Forgot VM password",
  "vmMoreActionsTitle": "More",
  "vmAutoShutdownAt": "Auto-shutdown at: ",
  "vmAutoShutdownNotSet": "Auto-shutdown not set",
  "timezonePacificAbbr": "PST",
  "timezoneMountainAbbr": "MST",
  "timezoneCentralAbbr": "CST",
  "timezoneEasternAbbr": "EST",
  "timezoneAtlanticAbbr": "AST",
  "timezoneNewfoundlandAbbr": "NST",
  "viewAutoShutdownSettingsFor": "View auto-shutdown settings for",
  "autoShutdownSettingsSavedPt1": "The auto-shutdown settings for the VM",
  "autoShutdownSettingsSavedSuccessfullyPt2": "were saved successfully",
  "autoShutdownSettingsNotSavedSuccessfullyPt2": "may not have saved successfully. Please refresh the page and review the auto-shutdown settings again"
}
